export { default } from "./FullScreenConfirmDialog.jsx";
